import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

export default function DealValueCell({ header, name, ...props }) {
  props.className = classNames('deal-cell', name, props.className);
  return header ? <th {...props}/> : <td {...props}/>;
}

DealValueCell.propTypes = {
  className: PropTypes.string,
  header: PropTypes.bool,
  name: PropTypes.string.isRequired,
};
